import { IoIosClose } from "react-icons/io";
import styles from "./Tag.module.scss";
import classNames from "classnames";

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  label: string;
  remove?: boolean;
  selected?: boolean;
}

export default function Tag(props: Props) {
  const { label, remove = false, selected = false, ...rest } = props;

  return (
    <button
      className={classNames(styles.tag, selected && styles.selected, remove && styles.removable)}
      {...rest}
    >
      {label}
      {remove && (
        <IoIosClose
          style={{
            width: 16,
            height: 16,
          }}
        />
      )}
    </button>
  );
}
